import { useState, useEffect } from 'react';

const useScrollTop = (elem) => {
	const [top, setTop] = useState(elem.pageYOffset);

	useEffect(() => {
		document.addEventListener(
			'scroll',
			function (e) {
				let t = elem.pageYOffset;
				if (top !== t) {
					setTop(t);
				}
			},
			true
		);
	});

	return { top };
};

export default useScrollTop;
